import Upgrade from './upgrade'
import { isComplete } from '../utils'

const MIN_TICK_TIME = 100

export default abstract class Solver extends Upgrade {
  // TODO: rethink factory pattern on load tomake private
  public solvingSpot: number;
  public timer?: number;
  public puzzle: number[][][];
  public skipCompleted: boolean;
  public skipCompleteCost: number;
  public recursive: boolean;
  public recursiveCost: number;
  public tickTime: number;
  public noAutos: number[];

  constructor (puzzle: number[][][], credits: Record<string, number>, noAutos: number[]) {
    super(credits)

    this.noAutos = noAutos
    this.puzzle = puzzle
    this.solvingSpot = -1
    this.tickTime = -1
    this.skipCompleted = false
    this.skipCompleteCost = 100
    this.recursive = false
    this.recursiveCost = 500
  }

  get current () {
    return this.tickTime
  }

  canUpgrade (): boolean {
    return (this.current < 0 || this.current > MIN_TICK_TIME) && super.canUpgrade()
  }

  get next () {
    return Math.max(MIN_TICK_TIME, Math.ceil(this.current * 0.90))
  }

  buy () {
    super.buy()
    if (this.tickTime < 0) {
      this.tickTime = 10000
    } else {
      this.tickTime = this.next
    }

    if (this.solvingSpot < 0) {
      this.solvingSpot = 0
    }
    this.run()
  }

  run () {
    if (this.tickTime <= 0) {
      return
    }
    // TODO: change this to convertableInterval
    if (this.timer) {
      clearInterval(this.timer)
    }
    this.timer = setInterval(() => {
      while (this.runSolver() > 0 && this.recursive) {}
      let tries = 0
      this.solvingSpot = (this.solvingSpot + 1) % 9
      while ((tries < 9 && this.skipCompleted && this.isComplete(this.solvingSpot) && !isComplete(this.puzzle)) || !this.shouldSolve(this.solvingSpot)) {
        this.solvingSpot = (this.solvingSpot + 1) % 9
        tries++
      }
    }, this.current)
  }

  solveVals (vals: number[][]): number {
    const filled = vals.filter((possible) => possible.length === 1).map((possible) => possible[0])
    let amtSolved = 0
    filled.forEach((num) => {
      vals.forEach((possible) => {
        if (possible.length === 1) {
          return
        }
        const index = possible.indexOf(num)
        if (index >= 0) {
          possible.splice(index, 1)
          if (possible.length === 1) {
            amtSolved++
          }
        }
      })
    })
    return amtSolved
  }

  unlockSkipCompleted () {
    this.credits.current -= this.skipCompleteCost
    this.skipCompleted = true
  }

  unlockRecursive () {
    this.credits.current -= this.recursiveCost
    this.recursive = true
  }

  canUnlockSkipComplete () {
    return !this.skipCompleted && this.credits.current >= this.skipCompleteCost
  }

  canUnlockRecursive () {
    return !this.recursive && this.credits.current >= this.recursiveCost
  }

  reset () {
    super.reset()
    clearInterval(this.timer)
    this.solvingSpot = -1
    this.tickTime = 10000
    this.skipCompleted = false
    this.skipCompleteCost = 100
    this.recursive = false
    this.recursiveCost = 500
  }

  serialize () {
    return Object.assign({}, super.serialize(), {
      solvingSpot: this.solvingSpot,
      tickTime: this.tickTime,
      skipCompleted: this.skipCompleted,
      skipCompleteCost: this.skipCompleteCost,
      recursive: this.recursive,
      recursiveCost: this.recursiveCost
    })
  }

  abstract runSolver(): number
  abstract isSolving(x: number, y: number): boolean
  abstract isComplete(solvingSpot: number): boolean
  abstract shouldSolve(solvingSpot: number): boolean
}
